// Full-document render of the Oscar basket view: PageSkeleton (the React
// document shell) wrapping the `#basket-app` mount point.
import React from "react";

import { templates } from "@reactivated";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import { BasketApp } from "../apps/checkout/BasketApp";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.BasketDocumentTemplate,
): React.JSX.Element => {
    const basketAppRef = React.useRef<HTMLDivElement>(null);
    // SiteHeader's promo bar (`.search-nav__promo`) isn't in this subtree --
    // it's chrome rendered by PageSkeleton -- so its presence has to be
    // detected via the document rather than props. When present it needs
    // extra clearance above the basket app.
    React.useEffect(() => {
        const document = getDocument();
        if (!document?.querySelector(".search-nav__promo")) {
            return;
        }
        if (basketAppRef.current) {
            basketAppRef.current.style.marginTop = "27px";
        }
    }, []);
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {/* The basket app lives in the document's React tree (mounted
                client-side by BasketApp; the dependency tree is not SSR-safe).
                The #basket-app id is retained for the 60-minute redirect timer
                in apps/checkout/index.tsx. */}
            <div
                id="basket-app"
                className="basket-container"
                ref={basketAppRef}
            >
                <BasketApp />
            </div>
        </PageSkeleton>
    );
};
